'use client';
import React, { useEffect, useRef, useState } from 'react';
import { useModal, MODAL_TYPES } from './ModalProvider';

export default function UtilityNavModalWrapper({
  isOpen,
  onClose,
  promoDisclaimer
}) {
  const modalRef = useRef(null);
  const [needsPadding, setNeedsPadding] = useState(false);
  const { modalUtils, getCloseButton } = useModal();

  // Ensure modal scrolls to top when opened and check if padding is needed
  useEffect(() => {
    if (isOpen && modalRef.current) {
      // Find the modal container with overflow-auto
      const modalContainer = modalRef.current.closest('.overflow-auto');
      if (modalContainer) {
        modalContainer.scrollTop = 0;

        // Check if content height fills the window height
        const containerHeight = modalContainer.offsetHeight;
        const scrollHeight = modalContainer.scrollHeight;

        // If content is scrollable (fills the window), add padding
        setNeedsPadding(scrollHeight > containerHeight);
      }
      // Also ensure the modal body itself is at top
      modalRef.current.scrollTop = 0;
    }
  }, [isOpen, promoDisclaimer]);

  if (!isOpen) return null;

  return modalUtils.createModalWrapper({
    modalType: MODAL_TYPES.utilityNav,
    isOpen,
    onClose,
    containerClassName: modalUtils.containerPresets.standard.basic,
    children: (
      <div
        ref={modalRef}
        id="modal-body-utility-nav"
        className={`modal-body body-r ${needsPadding ? 'p-4' : ''}`}
        tabIndex={-1}
      >
        {getCloseButton(MODAL_TYPES.utilityNav, onClose)}
        <div dangerouslySetInnerHTML={{ __html: promoDisclaimer }} />
      </div>
    )
  });
}
